import 'keen-slider/keen-slider.min.css';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { KeenSliderPlugin, useKeenSlider } from 'keen-slider/react';
import { getLanguageCode } from 'utils/localization/language';
import { getIsTranslationAvailable } from 'utils/translations';
import { getIsRtlLanguage } from '@daedalus/core/src/auth/modules/selectors';
import { Review } from '@findhotel/sapi';
import { ReviewCarouselCard } from './ReviewCarouselCard';
interface Props {
  /** Array of reviews */
  reviews?: Review[];
  /** Click event for read more and carousel card click */
  handleReadMoreClick?: () => void;
}
const CarouselWrapper = /*#__PURE__*/styled('div')({
  name: "CarouselWrapper",
  class: "c197s09m",
  propsAsIs: false
});
const MutationPlugin: KeenSliderPlugin = slider => {
  const observer = new MutationObserver(mutations => {
    mutations.forEach(() => {
      slider.update();
    });
  });
  const config = {
    childList: true
  };
  slider.on('created', () => {
    observer.observe(slider.container, config);
  });
  slider.on('destroyed', () => {
    observer.disconnect();
  });
};
export const ReviewCarousel = ({
  reviews,
  handleReadMoreClick
}: Props) => {
  const [isInitialized, setIsInitialized] = useState(false);
  const isRtl = useSelector(getIsRtlLanguage);
  // Using ref because of keen-slider makes closure when is being initialized
  const reviewsRef = useRef(reviews);
  const languageCode = useSelector(getLanguageCode);
  const [sliderRef, instanceRef] = useKeenSlider<HTMLDivElement>({
    loop: false,
    rtl: isRtl,
    initial: 0,
    slides: (size, slides) => {
      return slides.map((slide, index) => {
        let origin = 0;
        let slideSize = 1 - 44 / size;
        switch (index) {
          case 0:
            origin = 0;
            break;
          case slides.length - 1:
            origin = 32 / size;
            break;
          default:
            origin = 22 / size;
            break;
        }
        if (slides.length === 1) {
          slideSize = 1 - 24 / size;
        }
        return {
          origin: origin,
          size: slideSize,
          spacing: 8 / size
        };
      });
    },
    created: slider => {
      setTimeout(() => {
        slider.update();
        setIsInitialized(true);
      }, 100);
    }
  }, [MutationPlugin]);

  // Added as part of f72fa251-guest-reviews-languages
  const hasTranslationButton: boolean = useMemo(() => {
    return reviews?.some(review => getIsTranslationAvailable(review.language, languageCode));
  }, [reviews, languageCode]);
  useEffect(() => {
    reviewsRef.current = reviews;
    instanceRef.current?.update();
  }, [instanceRef, reviews]);
  return <CarouselWrapper ref={sliderRef} className="keen-slider" data-id="hotelReviewsCarousel">
      {reviewsRef?.current?.map((review, index) => <div key={`${index}-${review.reviewerScore}-${review.reviewDate}`} className="keen-slider__slide" data-id="hotelReviewsCarouselItem">
          {/* Truncated content height calculated incorrectly, if review card rendered before all slider calculations done */}
          {isInitialized && <ReviewCarouselCard review={review} onReadMoreClick={handleReadMoreClick} hasTranslationButton={hasTranslationButton} // Added as part of f72fa251-guest-reviews-languages
      />}
        </div>)}
    </CarouselWrapper>;
};

require("./ReviewCarousel.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ReviewCarousel.tsx");